import { IMasterProduct } from "./masterCategories.types";

export const defaultMasterProduct: IMasterProduct = {
  product_uuid: null,
  product_name: "",
  product_code_prefix: "",
  running_no: "",
  item_type: "",
  hsn_code: "",
  unit: "",
  product_type: "",
  gst: 0,
  cess: "",
  cess_amount: "",
  no_itc: "",
  category_uuid: "",
  category_name: "",
  billing_company_uuid: "",
  billing_company_branch_uuid: "",
  unit_price: 0,
  sell_price: "",
  sell_price_tax: "",
  purchase_price: "",
  purchase_price_tax: "",
  image: null,
  colour: "",
  description: "",
  status: "",
  combined_product_code: "",
  HSN_code: "",
};
